import Model from '~/models/Model'

export default class MySkillProposals extends Model {
  static get resource () {
    return 'freelancer/my-skill-proposals'
  }
}
